import styled from 'styled-components';

export default styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  bottom: 8px;
  width: calc(100% - 16px);
  max-width: 455px;
  z-index: 90;
  padding: 16px;
  box-sizing: border-box;

  border-radius: 4px;
  background: rgba(0, 0, 0, 0.90);

  @media (max-width: 768px) {
    max-width: calc(100% - 16px);
  }

  button {
    border-radius: 4px;
    border: 1px solid #1F1F1F;
    background: #1F1F1F;
    padding: 8px 12px;
    margin: 0;
    transition: background-color ease-in-out .2s;
    color: #FFFFFF;
    cursor: pointer;

    &:hover {
      background: #262626;
    }

    &:disabled {
      background: #141414;
      color: #424242;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  .quiz__btn {
    color: #FFF;

    &--left,
    &--right {
      height: 32px;
      width: 32px;
    }

    &--close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
    }
  }

  .quiz__backdrop {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: -1;
  }

  .quiz__container {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
  }

  .quiz__content {
    color: var(--gray-05, #D9D9D9);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: -0.28px;
    height: calc(100% - 88px);
    overflow: auto;
    width: 100%;
    scrollbar-width: thin;
  }

  .quiz__heading {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    h1 {
      width: 100%;
      text-align: left;
    }

    button {
      width: 40px;
      height: 40px;
    }

    svg {
      width: 12px;
      height: 12px;
    }
  }

  .quiz__footer {
    gap: 8px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .quiz__title {
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: -0.28px;
    margin: 10px 0;
  }

  .quiz_hr,
  .quiz_questionHr {
    border: 0;
    background: #616161;
    display: flex;
    height: 1px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    margin: 0;
  }

  .quiz_questionHr {
    margin: 8px 0;
  }

  .quiz__questionTitle {
    display: flex;
    padding: 0px 0px 15px;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    color: #FFFFFF;
  }

  .quiz__questionAnswers {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;

    input {
      visibility: hidden;
      width: 0;
      height: 0;
      opacity: 0;

      + label {
        color: #D9D9D9;
        border: 1px solid transparent;
        transition: ease-in-out .3s border, ease-in-out .3s color;
      }

      &.quiz__questionAnswers--empty + label {
        color: #595959;
        pointer-events: none;
      }

      &.quiz__questionAnswers--correct + label {
        color: #FFFFFF;
        border: 1px solid #4CAF50;
        pointer-events: none;
      }

      &:checked {
        &.quiz__questionAnswers--wrong + label {
          color: #FFFFFF;
          border: 1px solid #FF4D4F;
          pointer-events: none;
        }
      }
    }
  }

  .quiz__footerCount {
    color: #FFFFFF;
    font-size: 12px;
  }

  .quiz__questionAnswer {
    width: 100%;
    display: flex;
    padding: 8px;
    align-items: center;
    align-self: stretch;
    border-radius: 4px;
    background-color: transparent;
    transition: ease-in-out .2s background-color;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
      background-color: #1F1F1F;
    }
  }

  .quiz__responses {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-row-gap: 8px;
    grid-column-gap: 8px;
    padding: 0 8px;
  }

  .quiz__response {
    height: 28px;
    line-height: 28px;
    padding: 0;
    margin: 0;
    text-align: center;
    color: #FFFFFF;
    background-color: #1F1F1F;
    border-radius: 4px;
    padding: 0 8px;

    &.quiz__questionAnswers--wrong {
      background-color: #F5222D;
    }

    &.quiz__questionAnswers--correct {
      background-color: #4CAF50;
    }
  }
`;
